var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 523,
    viewBox: "0 0 375 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-64.091 175.946L41.8766 77.3312L175.811 116.948L281.411 23.54L405.589 65.3475",
    stroke: "url(#paint0_linear_119_2)",
    strokeWidth: 21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-185.266 215.969L-47.3089 259.807L56.8272 166.728L192.226 206.016L286.605 115.128",
    stroke: "url(#paint1_linear_119_2)",
    strokeWidth: 21
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-47.0632 411.164L58.9045 312.549L192.839 352.166L298.439 258.758L422.617 300.566",
    stroke: "url(#paint2_linear_119_2)",
    strokeOpacity: 0.5,
    strokeWidth: 21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-168.239 451.187L-30.2811 495.025L73.855 401.946L209.253 441.233L303.632 350.346",
    stroke: "url(#paint3_linear_119_2)",
    strokeOpacity: 0.5,
    strokeWidth: 21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_2",
    x1: 155.302,
    y1: 51.8598,
    x2: 171.297,
    y2: 123.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_2",
    x1: 66.1163,
    y1: 234.335,
    x2: 50.1213,
    y2: 163.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_119_2",
    x1: 172.33,
    y1: 287.078,
    x2: 188.325,
    y2: 358.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_119_2",
    x1: 83.1441,
    y1: 469.553,
    x2: 67.1492,
    y2: 398.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpBackground);
export default __webpack_public_path__ + "static/media/signUp_Background.0d54554bbaa731b4f2160637b4bb381a.svg";
export { ForwardRef as ReactComponent };